module.exports = __webpack_public_path__ + "static/media/araña.14584240.png";